import { Pipe, PipeTransform } from '@angular/core'

import { NUMBER_MINUS_ONE } from '../../../constants/constant.numbers'

@Pipe({
  name: 'sort',
})
export class SortPipe implements PipeTransform {
  transform(array: any, property: string): any {
    let propertyArray: string[]
    if (array) {
      if (property.indexOf('.') > NUMBER_MINUS_ONE) {
        propertyArray = property.split('.')
        array.sort(
          this.dynamicSortWithMultProp(propertyArray[0], propertyArray[1]),
        )
        return array
      } else if (property.indexOf('/') > NUMBER_MINUS_ONE) {
        let isAscending = true
        if (property[0] === '-') {
          isAscending = false
          property = property.substring(1)
        }
        property = property.split('/')[0]
        return this.sortDateStrings(array, isAscending, property)
      }
      array.sort(this.dynamicSort(property))
    }
    return array
  }

  dynamicSort(property: string) {
    let sortOrder = 1,
      result: number
    if (property[0] === '-') {
      sortOrder = NUMBER_MINUS_ONE
      property = property.substring(1)
    }

    // eslint-disable-next-line complexity
    return function (a: any, b: any) {
      if (a[property] && b[property]) {
        if (property === 'fundName') {
          result =
            a[property].toLowerCase() < b[property].toLowerCase()
              ? NUMBER_MINUS_ONE
              : a[property].toLowerCase() > b[property].toLowerCase()
              ? 1
              : 0
        } else {
          result =
            a[property] < b[property]
              ? NUMBER_MINUS_ONE
              : a[property] > b[property]
              ? 1
              : 0
        }
        return result * sortOrder
      }
      return !a[property] ? 1 : NUMBER_MINUS_ONE
    }
  }
  sortDateStrings(dateStrings: [], ascending: boolean, property: string) {
    return dateStrings.sort((a, b) => {
      const dateA = new Date(a[property]).getTime()
      const dateB = new Date(b[property]).getTime()
      return ascending ? dateA - dateB : dateB - dateA
    })
  }
  dynamicSortWithMultProp(property: string, key: any) {
    let sortOrder = 1,
      result: number
    if (property[0] === '-') {
      sortOrder = NUMBER_MINUS_ONE
      property = property.substring(1)
    }
    // eslint-disable-next-line complexity
    return function (a: any, b: any) {
      if (a[property] && a[property][key] && b[property] && b[property][key]) {
        result =
          a[property][key] < b[property][key]
            ? NUMBER_MINUS_ONE
            : a[property][key] > b[property][key]
            ? 1
            : 0
        return result * sortOrder
      }
      return !a[property][key] ? 1 : NUMBER_MINUS_ONE
    }
  }
}
